import React, { ChangeEvent, useEffect, useState } from 'react'
import { Autocomplete, TextField, Theme, Chip } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import { makeStyles } from '@mui/styles'

export interface DropDownElement {
  key: string
  value: string
  color?: string
}

interface IDropDownComponentData {
  options: DropDownElement[]
  multiple?: boolean
  id?: string
  name?: string
  margin?: 'normal' | 'dense' | 'none'
  label: string
  value?: string | DropDownElement[]
  inputValue?: string
  required?: boolean
  defaultValue?: any
  onChange?: (value: DropDownElement) => void
  onInputChange?: (newInputValue: string) => void
  disableClearable?: boolean
  disabled?: boolean
  placeholder?: string
  limitTags?: number | undefined
  size?: 'medium' | 'small' | undefined
  helperText?: string
  error?: boolean
  variant?: 'outlined' | 'filled' | 'standard'
  fullWidth?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    minWidth: '200px',
    // maxHeight: '19px',
  },
}))
const DropDownComponent: React.FC<IDropDownComponentData> = (props) => {
  const classes = useStyles()

  const extractValue = (): DropDownElement | DropDownElement[] | null => {
    let response: DropDownElement | DropDownElement[] | null = null
    if (props.multiple) {
      if (typeof (props.value) === 'string') {
        const elem = props.value && props.options.find((elem: DropDownElement) => elem.key === props.value)
        response = []
        elem && response.push(elem)
      } else {
        response = []
        if (props.value) {
          response = props.value
        }
      }
    } else {
      if (typeof (props.value) === 'string') {
        const elem = props.value && props.options.find((elem: DropDownElement) => elem.key === props.value)
        if (elem) {
          response = elem
        }
      } else {
        response = null
      }
    }
    return response
  }

  const [value, setValue] = useState<DropDownElement | DropDownElement[] | null>(extractValue())

  useEffect(() => {
    setValue(extractValue())
  }, [props.value],
  )

  return (
    <Autocomplete
      options={props.options}
      multiple={props.multiple ? props.multiple : false}
      value={value}
      inputValue={props.inputValue}
      onInputChange={(event, newInputValue) => props.onInputChange && props.onInputChange(newInputValue)}
      id={props.id}
      size={props.size}
      limitTags={props.limitTags}
      defaultValue={props.defaultValue}
      isOptionEqualToValue={(option: any, value) => option.value === value.value}
      getOptionLabel={(option: any) => option.value}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={index}
            style={{ backgroundColor: (option.color && props.multiple) ? option.color : '' }}
            label={option.value}
          />
        ))}
      renderOption={(prop, option, { selected }) => (
        <li {...prop} style={{ borderRight: (option.color && !props.multiple) ? `3px solid ${option.color}` : '' }}>
          {option.value}
        </li>
      )}
      onChange={(event: ChangeEvent<any>, value: any) => {
        setValue(value)
        props.onChange && props.onChange(value)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          name={props.name}
          placeholder={props.placeholder}
          required={props.required}
          helperText={props.helperText}
          error={props.error}
          InputLabelProps={{
            shrink: true,
          }}
          variant={props.variant}
          margin={props.margin}
        />
      )}
      className={classes.root}
      disableClearable={props.disableClearable ? props.disableClearable : false}
      disabled={props.disabled ? props.disabled : false}
      popupIcon={<KeyboardArrowDownIcon />}
      fullWidth={props.fullWidth}
    />
  )
}
export default DropDownComponent
